/**
 * The desktop app's mini window (desktop/malkavrs/src/mini-mode.js, Robert,
 * 2026-10-29: "picture in picture appears ... when you close the large
 * window"). When the window closes during a call, it shows one tile of the
 * room, uncropped: the one this module picks.
 */
import { systemPipParticipantId } from './systemPip';
/**
 * The same person as the phone's picture-in-picture window (systemPip.ts):
 * the first remote person in the stage order with video, which is the
 * interpreter on an interpreted call. Else the first remote person, else a
 * remote place that waits for a person ("Waiting for the interpreter"), else
 * the first tile (alone in the room).
 *
 * @param {Array} candidates - The stage tiles in the stage order.
 * @returns {string|undefined} The tile's key.
 */
export function desktopMiniPaneKey(candidates) {
    const chosen = systemPipParticipantId(candidates);
    if (chosen) {
        return candidates.find(candidate => candidate.participantId === chosen)?.key;
    }
    return (candidates.find(candidate => !candidate.local && candidate.participantId)
        || candidates.find(candidate => !candidate.local)
        || candidates[0])?.key;
}
